export enum PermissionMapTypeEnum {
  Role = 0,
  Submission = 1
}
